import * as React from 'react';
import { Text } from '@chakra-ui/react';

import { UploadActions, UploadButtonSection, UploadComplete as UploadCompleteSection, Modal } from 'shared-components';

interface IProps {
  complete: boolean;
  label?: string;
  description?: string;
  fileNames: string[];
  onContinue: () => void;
  onUpload: () => void;
  onClose: () => void;
}

const CustomRequestModal: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal id={'transcript'} show={true} title={'Custom Request Document'} onClose={props.onClose} hideFooter>
      {props.complete ? (
        <UploadCompleteSection fileNames={props.fileNames} onUpload={props.onUpload} onContinue={props.onContinue} />
      ) : (
        <>
          <Text>{props.description}</Text>

          <UploadButtonSection onUpload={props.onUpload}>
            Awaiting upload of <b>{`${props.label ? props.label : 'Custom Request Document'}`}</b>
          </UploadButtonSection>

          <UploadActions showEmail={false} complete={props.complete} onContinue={props.onContinue} />
        </>
      )}
    </Modal>
  );
};

export default CustomRequestModal;
